<template>
  <!-- 增加处理只有一张banner不需要轮播但需要跳转链接的情况 -->
  <div class="banner" v-if="list.length === 1">
    <img
      :src="list[0].img"
      class="slide-img"
      alt="banner"
      @click="jumpLink(list[0].link)"
    />
  </div>
  <div
    class="banner banner-swiper-container swiper-container"
    v-else-if="list.length > 1"
  >
    <div class="swiper-wrapper">
      <a
        class="swiper-slide"
        v-for="(item, index) in list"
        :key="index"
        :href="getActivityLink(item.link)"
        target="_blank"
        :pointValue="item.link"
      >
        <img
          :src="item.img"
          class="slide-img j-slide-banner"
          alt="banner-img"
        />
      </a>
    </div>
    <div class="swiper-pagination"></div>
  </div>
  <div class="banner" v-else>
    <img :src="defaultImg" class="slide-img" alt="banner" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Swiper from 'swiper';
import globalConfig from '@utiles/officialStore/globalConfig';
import openActivity, { BANNER_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export default {
  computed: {
    ...mapGetters(['gameInfoConfig', 'configDefaultLang']),
    ...mapState({
      lang: state => state.lang,
      gameId: state => state.gameId
    }),
    defaultImg() {
      return this.gameInfoConfig?.banner?.defaultImg || '';
    },
    list() {
      // 2024.08.21 星谕需求：rov,gnjoy.hk独有活动banner，后面确认全部放开可去掉
      if (+this.gameId === 371 && globalConfig.getMainHost() !== 'gnjoy.hk') {
        return [];
      }
      return (
        this.gameInfoConfig?.banner?.list?.[this.lang] ||
        this.gameInfoConfig?.banner?.list?.[this.configDefaultLang] ||
        []
      );
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  watch: {
    lang() {
      this.initSwiper();
    }
  },
  methods: {
    getActivityLink(activityUrl) {
      if (!activityUrl) return '';
      // 判断是不是pwa
      const boolPwa = globalConfig.getHrefParam('mode') === 'pwa';
      let payCid = '';
      let payScid = '';
      if (boolPwa) {
        try {
          const localPwaActivityCidStr =
            window.localStorage.getItem('pwaActivityScid');
          const localPwaActivityCidObj = JSON.parse(localPwaActivityCidStr);
          payCid = localPwaActivityCidObj?.cid || '';
          payScid = localPwaActivityCidObj?.scid || '';
        } catch (e) {
          console.error(e);
        }
      } else {
        payCid = globalConfig.getHrefParam('cid');
        payScid = globalConfig.getHrefParam('scid');
      }
      let activityCid = payCid;
      let activityScid = '';
      activityScid = payScid
        ? `${payScid}_${BANNER_ACTIVITY}`
        : BANNER_ACTIVITY;
      let link = activityUrl;
      let obj = {
        cid: activityCid,
        scid: activityScid,
        language: this.lang,
        appLanguage: this.lang,
        ...getGlobalGetLinkParams()
      };
      let newUrl = '';
      try {
        // 判断是否有加https或者http协议
        if (!(link.startsWith('http:') || link.startsWith('https:'))) {
          link = (window?.location?.protocol || 'https:') + link;
        }
        let url = new URL(link);
        for (let k in obj) {
          url.searchParams.set(k, String(obj[k]));
        }
        newUrl = url.href;
      } catch (error) {
        newUrl = String(link);
      }
      return newUrl || '';
    },
    jumpLink(link) {
      openActivity(BANNER_ACTIVITY, link, {
        language: this.lang,
        appLanguage: this.lang,
        ...getGlobalGetLinkParams()
      });
    },
    initSwiper() {
      try {
        new Swiper('.banner-swiper-container', {
          loop: true,
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          direction: 'horizontal',
          pagination: {
            el: '.swiper-pagination'
          },
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  display: block;
  width: 710px;
  height: 334px;
  margin: 20px auto;
}
.slide-img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.swiper-pagination {
  text-align: right;
  bottom: 21px;
}
@media screen and (orientation: landscape) {
  .banner {
    width: 100%;
    height: 170px;
    margin: 0 auto;
  }
}
</style>

<style lang="scss">
@import '@assets/scss/officialWebStore/_dimen.scss';
.swiper-pagination-bullet {
  background: #fff;
  width: 12px;
  height: 12px;
  opacity: 1;
  margin: 0 5px;
}
.swiper-pagination-bullet-active {
  background: $btnBg;
}
</style>
